<template>
  <v-dialog v-model="dialog" max-width="546px">
    <v-card>
      <v-card-title
        class="text-h5 white--text card-style"
        style="background-color: #4193cc"
      >
        Upload File
      </v-card-title>
      <v-card-text class="mt-6">
        <div
          class="upload-area"
          @click="triggerFileUpload"
          @dragover.prevent="onDragOver"
          @dragleave="onDragLeave"
          @drop.prevent="onFileDropped"
          :class="{ 'drag-over': isDragging }"
        >
          <div v-if="!file">
            <v-icon class="icon-style">mdi-file-upload</v-icon>
            <div class="text-style">อัพโหลดไฟล์</div>
            <input
              type="file"
              ref="fileInput"
              style="display: none"
              @change="onFileSelected"
              accept="application/pdf"
            />
          </div>
          <div v-else>
            <div
              v-if="fileName"
              class="file-info d-flex align-center justify-space-between mt-2"
            >
              <span>{{ fileName }}</span>
              <v-btn icon @click="removeFile" class="remove-btn">
                <v-icon color="#F44336">mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <p v-if="fileError" class="error-text">{{ fileError }}</p>
      </v-card-text>
      <v-card-actions>
        <v-btn class="cancel-btn" @click="closeDialog">Cancel</v-btn>
        <v-btn class="save-btn" :disabled="!isFileUploaded" @click="saveFile"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from "../event-bus";
import Swal from "sweetalert2";
export default {
  name: "DialogUpload",
  data: () => ({
    dialog: false,
    file: null,
    fileName: "",
    isDragging: false,
    fileError: "",
    biz_id: "",
  }),
  computed: {
    isFileUploaded() {
      return !!this.file;
    },
  },
  created() {
    this.biz_id = localStorage.getItem("biz_id");
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    onFileSelected(event) {
      const selectedFile = event.target.files[0];
      this.validateFile(selectedFile);
    },
    onFileDropped(event) {
      const droppedFile = event.dataTransfer.files[0];
      this.validateFile(droppedFile);
      this.isDragging = false;
    },
    validateFile(file) {
      if (file && file.type === "application/pdf") {
        this.setFile(file);
        this.fileError = "";
      } else {
        this.fileError = "กรุณาอัพโหลดไฟล์ PDF เท่านั้น";
        this.removeFile();
      }
    },
    setFile(file) {
      this.file = file;
      this.fileName = file.name;
    },
    removeFile() {
      this.file = null;
      this.fileName = "";
    },
    closeDialog() {
      this.dialog = false;
      this.removeFile();
      this.fileError = "";
    },

    saveFile() {
      let headers = {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization:
            "Bearer " +
            localStorage.getItem("acces_token") +
            "," +
            localStorage.getItem("secret"),
        },
        responseType: "blob",
      };
      this.getFileBase64(this.file)
        .then((fileData) => {
          let data = {
            file: [
              {
                name: this.fileName,
                type: this.file.type,
                data_base64: fileData.split(",")[1],
              },
            ],
          };
          return this.axios.post(process.env.VUE_APP_API + "/file/update/filetooling?biz_id=" + this.biz_id, data, headers);
        })
        .then((response) => {
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "ไฟล์ถูกอัพโหลดสำเร็จ",
              showConfirmButton: false,
              timer: 6500,
            });
            this.dialog = false;
            this.removeFile();
          }
        })
        .catch((error) => {
          if (error) {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาดในการอัพโหลดไฟล์",
              showConfirmButton: false,
              timer: 119500,
              customClass: {
                icon: "my-icon-class",
                title: "my-title-class",
              },
            });
          }
        });
    },

    getFileBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
  },
  mounted() {
    eventBus.$on("openDialogUpload", this.openDialog);
  },
  beforeDestroy() {
    eventBus.$off("openDialogUpload");
  },
};
</script>

<style scoped>
.card-style {
  font-family: "Bai_Jamjuree" !important;
}
.v-dialog {
  font-family: "Bai_Jamjuree" !important;
}
.upload-area {
  border: 2px dashed #ccc !important;
  border-radius: 8px !important;
  padding: 10px !important;
  text-align: center !important;
  font-size: 14px !important;
  color: #666 !important;
  height: 150px !important;
  transition: background-color 0.3s ease;
}
.upload-area.drag-over {
  background-color: #e0f7fa;
  border-color: #03a9f4;
}
.upload-area .v-input__prepend-inner .v-icon {
  font-size: 24px !important;
  color: #666 !important;
}
.text-style {
  display: flex !important;
  justify-content: center !important;
  font-family: "Bai_Jamjuree" !important;
}
.icon-style {
  font-size: 95px !important;
  margin-top: 6px !important;
  color: darkgray !important;
}
.v-card__actions {
  align-items: center !important;
  display: flex !important;
  justify-content: center !important;
}
.error-text {
  color: #f44336 !important;
  font-size: 16px !important;
  text-align: center !important;
  margin-top: 5px !important;
  font-family: "Bai_Jamjuree" !important;
}
.cancel-btn {
  background-color: #f44336 !important;
  color: #fff !important;
  font-family: "Bai_Jamjuree" !important;
}
.save-btn {
  background-color: #1976d2 !important;
  color: #fff !important;
  font-family: "Bai_Jamjuree" !important;
}
</style>
